import union from 'lodash/union';
import { combineReducers } from 'redux';

import * as types from '../../types';

const byId = (state = {}, action) => {
  switch (action.type) {
    case types.USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED: {
      const { entities, order } = action.payload;
      const newState = {};
      order.forEach((notifId) => {
        newState[notifId] = {
          isSelected: false,
          ...entities[notifId],
          isConfirmed: true,
          shownAtLogin: false
        };
      });
      return newState;
    }

    case types.USER_NOTIFICATION_READ_COMPLETED: {
      const { notifications, notificationIds } = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId, index) => {
        if (newState[notificationId]) {
          newState[notificationId] = {
            ...newState[notificationId],
            ...notifications[index],
            readStatus: 2, // Mark as read
            isConfirmed: true,
            shownAtLogin: true
          };
        }
      });
      return newState;
    }

    case types.USER_NOTIFICATION_READ_STARTED: {
      const notificationIds = action.payload;
      const newState = { ...state };
      notificationIds.forEach((notificationId) => {
        if (newState[notificationId]) {
          newState[notificationId] = {
            ...newState[notificationId],
            readStatus: 2, // Mark as read optimistically
            isConfirmed: false,
            shownAtLogin: true
          };
        }
      });
      return newState;
    }

    default: {
      return state;
    }
  }
};

const order = (state = [], action) => {
  switch (action.type) {
    case types.USER_PUSH_NOTIFICATIONS_FETCH_COMPLETED: {
      const { order } = action.payload;
      return union(order);
    }

    default: {
      return state;
    }
  }
};

export const events = combineReducers({
  byId,
  order
});
